import { call, put, takeEvery } from 'redux-saga/effects';
import { AxiosResponse } from 'axios';
import { services } from 'globals/app';
import * as serieActions from 'ducks/serie';
import { PopularMoviesResponse } from 'types/api';


function* getSeriesRequested( payload : any) {
  try {
    const response: AxiosResponse<PopularMoviesResponse> = yield call([services.serie, services.serie.getTrendingSeries], payload);
    yield put(serieActions.getSerieAsync.success(response.data.results));
  } catch (err) {
    yield put(serieActions.getSerieAsync.failure(err));
  }
}

export function* seriesSagas() {
  yield takeEvery(serieActions.GET_SERIES_REQUESTED, getSeriesRequested)
}